"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./ObjectsInMap"), exports);
__exportStar(require("./Panorama"), exports);
__exportStar(require("./LocationPoint"), exports);
__exportStar(require("./MapContainer"), exports);
__exportStar(require("./MapObject"), exports);
__exportStar(require("./MapObjectProps"), exports);
__exportStar(require("./useMap"), exports);
// Automatické přidání odkazů na Bootstrap a Bootstrap Icons do hlavičky HTML
(function addBootstrapToHead() {
    const linkLeaflet = document.createElement("link");
    linkLeaflet.rel = "stylesheet";
    linkLeaflet.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
    document.head.appendChild(linkLeaflet);
    const linkLeaflet2 = document.createElement("script");
    linkLeaflet2.integrity =
        "sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=";
    linkLeaflet2.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
    linkLeaflet2.crossOrigin = "";
    document.head.appendChild(linkLeaflet2);
})();
// <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"
//     integrity="sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY="
//     crossorigin=""/>
//     <script src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"
//     integrity="sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo="
//     crossorigin=""></script>
